import React, {useEffect } from "react";
import apiService from "../services/api";

const Lyrics = ({lyricsStatus,currentSong,lyrics,setLyrics})=>{

    useEffect(()=>{
        if (currentSong?.id && currentSong.hasLyrics) {
            apiService.getLyrics(currentSong.id).then(data => {
                if (data) setLyrics({ data: data });
                else setLyrics({});
            });
        }
    }, [currentSong?.id, currentSong?.hasLyrics, setLyrics])
    
    return(
        <div className={`lyrics ${lyricsStatus ? 'active-lyrics' : '' }`}>
            <h2>Lyrics</h2>
            {currentSong?.hasLyrics ? (lyrics.hasOwnProperty('data') ? <LyricsRenderer lyrics={lyrics?.data?.lyrics} /> : <h3>Not available.</h3>) : <h3>Not available.</h3>}
        </div>
    )
}

const LyricsRenderer = ({ lyrics }) => {
    // Split the lyrics by <br> tag to get individual lines
    const lines = lyrics.split('<br>');
  
    return (
      <h3>
        {lines.map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </h3>
    );
};

export default Lyrics;